export default "__VITE_ASSET__DVYDRXow__"